import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TooltipIconComponent } from '../../../../shared/components/tooltip-icon/tooltip-icon.component';

type MetricCellRendererParams = ICellRendererParams & { tooltip?: string };

@Component({
  selector: 'app-metric-cell-renderer',
  imports: [TooltipIconComponent],
  templateUrl: './metric-cell-renderer.component.html',
  styleUrl: './metric-cell-renderer.component.scss',
})
export class MetricCellRendererComponent implements ICellRendererAngularComp {
  value: string = '';
  tooltip: string = '';

  agInit(params: MetricCellRendererParams): void {
    this.value = params.value ?? '';
    this.tooltip = params.tooltip ?? '';
  }

  refresh(params: MetricCellRendererParams): boolean {
    this.value = params.value ?? '';
    this.tooltip = params.tooltip ?? '';
    return true;
  }
}
